/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetResponsesUsageRequest = {
  startTime: number;
  endTime?: number | undefined;
  bucketWidth?: components.BucketWidth | undefined;
  limit?: number | undefined;
  page?: string | undefined;
  userIds?: Array<string> | undefined;
  externalUserIds?: Array<string> | undefined;
  allOrgs?: string | undefined;
  orgIds?: Array<string> | undefined;
  groupBy?: Array<components.ResponsesGroupBy> | undefined;
  models?: Array<string> | undefined;
  background?: boolean | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

export type GetResponsesUsageData = {
  object: "bucket";
  /**
   * Unix timestamp of bucket start (inclusive)
   */
  startTime: number;
  /**
   * Unix timestamp of bucket end (exclusive)
   */
  endTime: number;
  /**
   * Array of usage results for this time bucket
   */
  results: Array<any | null>;
};

/**
 * OK
 */
export type GetResponsesUsageResponseBody = {
  object: "page";
  data: Array<GetResponsesUsageData>;
  /**
   * Whether there are more pages
   */
  hasMore: boolean;
  /**
   * Cursor for next page, null if no more pages
   */
  nextPage: string | null;
};

/** @internal */
export const GetResponsesUsageRequest$inboundSchema: z.ZodType<
  GetResponsesUsageRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  start_time: z.number().int(),
  end_time: z.number().int().optional(),
  bucket_width: components.BucketWidth$inboundSchema.default("1d"),
  limit: z.number().int().optional(),
  page: z.string().optional(),
  user_ids: z.array(z.string()).optional(),
  external_user_ids: z.array(z.string()).optional(),
  all_orgs: z.string().optional(),
  org_ids: z.array(z.string()).optional(),
  group_by: z.array(components.ResponsesGroupBy$inboundSchema).optional(),
  models: z.array(z.string()).optional(),
  background: z.boolean().optional(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "start_time": "startTime",
    "end_time": "endTime",
    "bucket_width": "bucketWidth",
    "user_ids": "userIds",
    "external_user_ids": "externalUserIds",
    "all_orgs": "allOrgs",
    "org_ids": "orgIds",
    "group_by": "groupBy",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetResponsesUsageRequest$Outbound = {
  start_time: number;
  end_time?: number | undefined;
  bucket_width: string;
  limit?: number | undefined;
  page?: string | undefined;
  user_ids?: Array<string> | undefined;
  external_user_ids?: Array<string> | undefined;
  all_orgs?: string | undefined;
  org_ids?: Array<string> | undefined;
  group_by?: Array<string> | undefined;
  models?: Array<string> | undefined;
  background?: boolean | undefined;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetResponsesUsageRequest$outboundSchema: z.ZodType<
  GetResponsesUsageRequest$Outbound,
  z.ZodTypeDef,
  GetResponsesUsageRequest
> = z.object({
  startTime: z.number().int(),
  endTime: z.number().int().optional(),
  bucketWidth: components.BucketWidth$outboundSchema.default("1d"),
  limit: z.number().int().optional(),
  page: z.string().optional(),
  userIds: z.array(z.string()).optional(),
  externalUserIds: z.array(z.string()).optional(),
  allOrgs: z.string().optional(),
  orgIds: z.array(z.string()).optional(),
  groupBy: z.array(components.ResponsesGroupBy$outboundSchema).optional(),
  models: z.array(z.string()).optional(),
  background: z.boolean().optional(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    startTime: "start_time",
    endTime: "end_time",
    bucketWidth: "bucket_width",
    userIds: "user_ids",
    externalUserIds: "external_user_ids",
    allOrgs: "all_orgs",
    orgIds: "org_ids",
    groupBy: "group_by",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getResponsesUsageRequestToJSON(
  getResponsesUsageRequest: GetResponsesUsageRequest,
): string {
  return JSON.stringify(
    GetResponsesUsageRequest$outboundSchema.parse(getResponsesUsageRequest),
  );
}
export function getResponsesUsageRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetResponsesUsageRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetResponsesUsageRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetResponsesUsageRequest' from JSON`,
  );
}

/** @internal */
export const GetResponsesUsageData$inboundSchema: z.ZodType<
  GetResponsesUsageData,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("bucket"),
  start_time: z.number().int(),
  end_time: z.number().int(),
  results: z.array(z.nullable(z.any())),
}).transform((v) => {
  return remap$(v, {
    "start_time": "startTime",
    "end_time": "endTime",
  });
});
/** @internal */
export type GetResponsesUsageData$Outbound = {
  object: "bucket";
  start_time: number;
  end_time: number;
  results: Array<any | null>;
};

/** @internal */
export const GetResponsesUsageData$outboundSchema: z.ZodType<
  GetResponsesUsageData$Outbound,
  z.ZodTypeDef,
  GetResponsesUsageData
> = z.object({
  object: z.literal("bucket"),
  startTime: z.number().int(),
  endTime: z.number().int(),
  results: z.array(z.nullable(z.any())),
}).transform((v) => {
  return remap$(v, {
    startTime: "start_time",
    endTime: "end_time",
  });
});

export function getResponsesUsageDataToJSON(
  getResponsesUsageData: GetResponsesUsageData,
): string {
  return JSON.stringify(
    GetResponsesUsageData$outboundSchema.parse(getResponsesUsageData),
  );
}
export function getResponsesUsageDataFromJSON(
  jsonString: string,
): SafeParseResult<GetResponsesUsageData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetResponsesUsageData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetResponsesUsageData' from JSON`,
  );
}

/** @internal */
export const GetResponsesUsageResponseBody$inboundSchema: z.ZodType<
  GetResponsesUsageResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("page"),
  data: z.array(z.lazy(() => GetResponsesUsageData$inboundSchema)),
  has_more: z.boolean(),
  next_page: z.nullable(z.string()),
}).transform((v) => {
  return remap$(v, {
    "has_more": "hasMore",
    "next_page": "nextPage",
  });
});
/** @internal */
export type GetResponsesUsageResponseBody$Outbound = {
  object: "page";
  data: Array<GetResponsesUsageData$Outbound>;
  has_more: boolean;
  next_page: string | null;
};

/** @internal */
export const GetResponsesUsageResponseBody$outboundSchema: z.ZodType<
  GetResponsesUsageResponseBody$Outbound,
  z.ZodTypeDef,
  GetResponsesUsageResponseBody
> = z.object({
  object: z.literal("page"),
  data: z.array(z.lazy(() => GetResponsesUsageData$outboundSchema)),
  hasMore: z.boolean(),
  nextPage: z.nullable(z.string()),
}).transform((v) => {
  return remap$(v, {
    hasMore: "has_more",
    nextPage: "next_page",
  });
});

export function getResponsesUsageResponseBodyToJSON(
  getResponsesUsageResponseBody: GetResponsesUsageResponseBody,
): string {
  return JSON.stringify(
    GetResponsesUsageResponseBody$outboundSchema.parse(
      getResponsesUsageResponseBody,
    ),
  );
}
export function getResponsesUsageResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<GetResponsesUsageResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetResponsesUsageResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetResponsesUsageResponseBody' from JSON`,
  );
}
